import Feature15 from './Feature15'
export default Feature15
